// Keenthemes' plugins
window.KTComponents = require('../metronic/js/components/_init.js');
window.KTUtil = require('../metronic/js/components/util.js');
window.KTApp = require('../metronic/js/components/app.js');
window.KTEventHandler = require('../metronic/js/components/event-handler.js');
window.KTBlockUI = require('../metronic/js/components/blockui.js');
window.KTCookie = require('../metronic/js/components/cookie.js');
window.KTDialer = require('../metronic/js/components/dialer.js');
window.KTDrawer = require('../metronic/js/components/drawer.js');
window.KTFeedback = require('../metronic/js/components/feedback.js');
window.KTImageInput = require('../metronic/js/components/image-input.js');
window.KTMenu = require('../metronic/js/components/menu.js');
window.KTPasswordMeter = require('../metronic/js/components/password-meter.js');
window.KTScroll = require('../metronic/js/components/scroll.js');
window.KTScrolltop = require('../metronic/js/components/scrolltop.js');
window.KTSearch = require('../metronic/js/components/search.js');
window.KTStepper = require('../metronic/js/components/stepper.js');
window.KTSticky = require('../metronic/js/components/sticky.js');
window.KTSwapper = require('../metronic/js/components/swapper.js');
window.KTToggle = require('../metronic/js/components/toggle.js');

// Layout base js
window.KTLayoutAside = require('../metronic/js/layout/aside.js');
window.KTLayoutSearch = require('../metronic/js/layout/search.js');
window.KTLayoutToolbar = require('../metronic/js/layout/toolbar.js');
window.KTThemeMode = require('../metronic/js/layout/theme-mode.js');
window.KTThemeModeUser = require('../metronic/js/layout/theme-mode-user.js');
